import { ORGANIZATION_SCHEMA_ID, buildWebPageSchemaId } from '../utils/structuredDataIdentity.js';

export const STOCKTAG_METADATA_STUDIO_VIDEO = {
  id: '8nVu_W60vwo',
  slug: 'stocktag-metadata-studio-demo',
  watchUrl: 'https://www.youtube.com/watch?v=8nVu_W60vwo',
  embedUrl: 'https://www.youtube-nocookie.com/embed/8nVu_W60vwo?rel=0',
  posterUrl: '/VIDEO-poster.webp',
  posterSrcSet: '/VIDEO-poster-512.webp 512w, /VIDEO-poster.webp 640w',
  thumbnailUrl: 'https://i.ytimg.com/vi/8nVu_W60vwo/maxresdefault.jpg',
  fallbackThumbnailUrl: 'https://i.ytimg.com/vi/8nVu_W60vwo/hqdefault.jpg',
  uploadDate: '2026-04-03T07:17:31-07:00',
  duration: 'PT1M31S',
  channelName: 'StocktagAI',
  youtubeTitle: 'Stock Photo Keyword Generator | Adobe, Shutterstock & Getty Images Keywords'
};

export const buildYouTubeTimestampUrl = (watchUrl, startSeconds = 0) => {
  const base = String(watchUrl || '').trim();
  if (!base) return '';
  const seconds = Number.isFinite(startSeconds) && startSeconds > 0 ? Math.max(0, Math.floor(startSeconds)) : 0;
  if (seconds === 0) return base;
  return `${base}${base.includes('?') ? '&' : '?'}t=${seconds}s`;
};

export const buildVideoObjectSchema = ({
  video,
  name,
  description,
  pageUrl,
  inLanguage = 'en-US'
}) => {
  if (!video?.embedUrl || !description) return null;

  const thumbnailUrl = [video.thumbnailUrl, video.fallbackThumbnailUrl].filter(Boolean);

  return {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: name || video.youtubeTitle,
    description,
    thumbnailUrl,
    uploadDate: video.uploadDate,
    duration: video.duration,
    embedUrl: video.embedUrl,
    url: video.watchUrl,
    inLanguage,
    publisher: {
      '@type': 'Organization',
      '@id': ORGANIZATION_SCHEMA_ID,
      name: 'Stocktag',
      url: 'https://www.stocktag.ai'
    },
    // The same @id as the page's own WebPage node, so the two resolve together.
    mainEntityOfPage: pageUrl ? {
      '@type': 'WebPage',
      '@id': buildWebPageSchemaId(pageUrl)
    } : undefined
  };
};
